import React from 'react';
import classes from './Radio.module.css';

const Radio = (props) => {
  let classesForWrapper, classesForCheckmark, classesForText;

  if (props.selected) {
    if (props.displayAsButton) {
      classesForWrapper = [
        classes.RadioButton,
        classes.RadioCircleSelected,
      ].join(' ');
      classesForText = [
        classes.RadioTextButton,
        classes.RadioTextButtonSelected,
      ].join(' ');
      classesForCheckmark = [
        classes.RadioCircle,
        classes.RadioCircleSelected,
        classes.RadioCircleButton,
      ].join(' ');
    } else {
      classesForWrapper = classes.Radio;
      classesForText = [classes.RadioText, classes.RadioTextSelected].join(' ');
      classesForCheckmark = [
        classes.RadioCircle,
        classes.RadioCircleSelected,
      ].join(' ');
    }
  } else {
    if (props.displayAsButton) {
      classesForWrapper = classes.RadioButton;
      classesForText = classes.RadioTextButton;
      classesForCheckmark = [
        classes.RadioCircle,
        classes.RadioCircleButton,
      ].join(' ');
    } else {
      classesForWrapper = classes.Radio;
      classesForText = classes.RadioText;
      classesForCheckmark = classes.RadioCircle;
    }
  }

  return (
    <div
      className={classesForWrapper}
      style={props.style}
      value={props.optionValue}
      onClick={props.radioClicked}
    >
      <div style={props.circleStyle} className={classesForCheckmark}>
        {props.withCheckmark ? (
          props.selected && (
            <svg className={classes.CheckMark}>
              <use xlinkHref='/sprites.svg#icon-check-inverted' />
            </svg>
          )
        ) : (
          <div
            className={classes.RadioInnerCircle}
            style={{ display: props.selected ? 'block' : 'none' }}
          />
        )}
      </div>
      <span style={props.textStyle} className={classesForText}>
        {props.optionText}
      </span>
    </div>
  );
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/UI/RadioGroup/Radio/Radio.js